import type { IColumnInfo } from '@dbl/core/dataSource';
import type { IColumnOptionRequest } from '@dbl/services/filter';
import { FilterMethod } from '@dbl/core/filter';
import { ALL_VALUE, OptionPageSize } from '@/pages/datalab/components/SortableDrag/configration';
import {
  AnalysisFilters,
  FiltersItem,
  GroupBy,
  MetricsItem,
} from '@/pages/datalab/pages/Multidimensional/Analysis/interface';
import { getGameCodeFromLocal, getSessionGlobalUserId } from '@/pages/datalab/utils/common';
import { getColunmOptions } from '@dbl/services/global';
import moment from 'moment';
import { formatDateRange, getDateRange } from '@dbl/core/date';
import { isEmpty } from 'lodash-es';

const service: {
  getColunmOptions: (params: IColumnOptionRequest) => Promise<unknown>;
} = { getColunmOptions };

export class BaseModel {
  reducers: {} = {
    save(state: any, action: { payload: any; }) {
      // console.log('payload', action.payload);
      return { ...state, ...action.payload };
    },
  };
  effects: {};

  constructor(namespace: string) {
    this.effects = this.effectsFun(namespace);
  }

  private effectsFun = (namespace: string) => ({
    *resetOptionNowFromAll({ payload }: { payload: any; }, { put, select }: { put: any; select: any; }): any {
      const { newColumnObj, sortableKey } = payload;
      const { table_id, column_name } = newColumnObj;

      const { [sortableKey]: filterModel } = yield select((state: { [x: string]: any; }) => state[namespace]);

      const columnObj: IColumnInfo = filterModel.find(
        (item: IColumnInfo) => item.table_id === table_id && item.column_name === column_name,
      );
      if (columnObj) {
        columnObj.options_now = columnObj.options_all;
        yield put({
          type: 'save',
          payload: {
            [sortableKey]: [...filterModel],
          },
        });
      }
    },
    *searchColumnOptionsList(
      { payload, callback }: { payload: any; callback: Function; },
      { put, select }: { put: any; select: any; },
    ): any {
      try {
        const {
          sortableKey,
          columnInfo,
          query,
          type,
          isDetail = false,
        }: { sortableKey: string; columnInfo: IColumnInfo; query: any[]; type: number; isDetail: boolean; } = payload;
        const { table_id, column_name, dimension_setting } = columnInfo;
        const gameCode = getGameCodeFromLocal();
        const { value_list = [] } = yield service.getColunmOptions({
          table_id,
          game_code: gameCode,
          dim_name: column_name,
          query,
          query_type: type,
          page_no: 1,
          page_size: OptionPageSize,
          dimension_setting,
        });
        const { [sortableKey]: filterModel } = yield select((state: { [x: string]: any; }) => state[namespace]);
        const columnObj: IColumnInfo = filterModel.find(
          (item: IColumnInfo) => item.table_id === table_id && item.column_name === column_name,
        );
        if (columnObj) {
          columnObj.options_now = [];
          const haveAllValueList = (columnObj.options_all || []).map((item: any) => item.value);
          columnObj.options_all = (columnObj.options_all || []).concat(
            (value_list || [])
              .filter((item: any) => (!haveAllValueList.includes(item.value) && (columnObj.isCommonDimension ? item.value !== ALL_VALUE : true)))
              .map((item: any) => ({
                text: item.display,
                value: item.value,
              }))
          );
          const haveValueList = (columnObj.options_now || []).map((item: any) => item.value);
          const newOptionsObjNameMap = isDetail
            ? (columnObj.options_now || []).concat(
              (value_list || []).filter((item: any) => (!haveValueList.includes(item.value)) && (columnObj.isCommonDimension ? item.value !== ALL_VALUE : true)),
            )
            : value_list || [];
          columnObj.options_now =
            newOptionsObjNameMap.map((item: any) => ({
              text: item.display || item.text,
              value: item.value,
            })) || [];
          yield put({
            type: 'save',
            payload: {
              [sortableKey]: [...filterModel],
            },
          });
        }
        if (callback) {
          callback();
        }
      } catch (e) {
        console.error(e);
      }
    },
    *getColumnOptionsList(
      { payload, callback }: { payload: any; callback: Function; },
      { put, select }: { put: any; select: any; },
    ): any {
      try {
        const { sortableKey, newOptionsObj, keyword } = payload;
        const { table_id, column_name, table_code } = newOptionsObj;
        const { [sortableKey]: filterModel, mode } = yield select((state: { [x: string]: any; }) => state[namespace]);
        const columnObj: IColumnInfo = filterModel.find(
          (item: IColumnInfo) => item.table_id === table_id && item.column_name === column_name && item.table_code === table_code,
        );
        if (columnObj) {
          if (!columnObj.options_req) {
            columnObj.options_req = {
              page_no: 1,
              page_size: OptionPageSize,
              has_next: true,
            };
          }
          const gameCode = getGameCodeFromLocal();
  
          try {
            const params: IColumnOptionRequest = {
              ...columnObj.options_req,
              game_code: gameCode,
              table_id: columnObj.table_id,
              dim_name: columnObj.column_name,
              // query_type: 0,
              dimension_setting: columnObj.dimension_setting,
              keyword,
            };
            const { value_list = [], total_size = 0 } = yield service.getColunmOptions(params);
            const { mode: mode2 } = yield select((state: { [x: string]: any; }) => state[namespace]);
            if (mode !== mode2) return; // 这个判断是为了防止 在聚合数据和原始数据切换过程中, 选项没有请求回来, 切换后, 自动添加了筛选项的问题.
            const haveOptionsList = columnObj.options_now || [];
            const haveOptionsValueList = haveOptionsList.map((item: any) => item.value);
            const newOptionsObjKeyOptionMap = (value_list || []).filter(
              (item: any) => !haveOptionsValueList.includes(item.value) && (columnObj.isCommonDimension ? item.value !== ALL_VALUE : true),
            );
    
            // const newOptionsList =
            //   newOptionsObjKeyOptionMap.map((item: any) => ({
            //     text: item.display || item.text,
            //     value: item.value,
            //   })) || [];
            // debugger;
            columnObj.searchOptions = keyword ? value_list : [];
            columnObj.options_now = [...(columnObj.options_now || []), ...newOptionsObjKeyOptionMap];
            columnObj.options_all = [...(columnObj.options_all || []), ...newOptionsObjKeyOptionMap];
            // columnObj.options_req.page_no = (columnObj.options_req?.page_no ?? 0) + 1;
            // columnObj.options_req.has_next = columnObj.options_all.length < total_size;
            columnObj.total = !keyword ? total_size : columnObj.total;
            const columnValues = columnObj.column_value || [];
            columnObj.column_value =
              columnObj.isAll ?  [] : columnValues;
            columnObj.loading = false;
          } catch (e) {
            columnObj.loading = false;
            columnObj.isError = true;
            console.error(`${columnObj.column_display} 下拉选项请求错误`, e);
          }
  
          yield put({
            type: 'save',
            payload: {
              [sortableKey]: [...filterModel],
            },
          });
          
          // if (columnObj.options_req.has_next) {
          //
          // }
        }
        if (callback) {
          callback();
        }
      } catch (e) {
        console.error(e);
      }
    },
  });
}

export const createGroupBy = (columnDimensions: IColumnInfo[]) => {
  const newGroupBy: GroupBy[] = (columnDimensions || []).map((item) => ({
    table_code: item.table_code || "t0",
    table_id: item.table_id,
    column: item.column_name,
    // label: isEn ? (item.column_display_en || item.column_display) : item.column_display,
    label: item.column_display,
    label_en: item.column_display_en || item.column_display,
    column_type: item.column_type,
    type: item.dimension_type,
    range: item.dimension_rangs,
    attribute: item.attribute,
    accuracy: item.accuracy,
    unit: item.unit,
    flag: item.flag,
    dimension_setting: item.dimension_setting,
    date_format: item.date_format,
    to_date_format: item.to_date_format || '',
  }));
  return newGroupBy;
};

export const createFiltersItem = (columnFilters: IColumnInfo[], isCalculate?: boolean) => {
  const newFilters: FiltersItem[] = (columnFilters || []).map((columnInfo) => {

    let value = columnInfo?.column_value;
    if (columnInfo?.column_type === 'string') {
      value = (columnInfo?.isAll ? [] : columnInfo?.column_value);
    }
    let operation = columnInfo.operation ?? '';
    // isCalculate 代表是计算接口
    if (isCalculate && columnInfo.operation === 'recent') { // 静态时间的 月粒度 时, value元素的格式要转换
      // 动态日期时, 上传的 value 和 operation要转换成静态日期值
      operation = 'between';
      value = columnInfo?.column_text?.split(' ~ ') ?? [];
      if (columnInfo.dateType === 'month') {
        value = [
          moment(value[0]).startOf('month').format('YYYY-MM-DD'),
          moment(value[1]).endOf('month').format('YYYY-MM-DD'),
        ];
      }
    }
    
    let compareTimes = [];
    if (columnInfo.compareTimes && columnInfo.compareTimes.length > 0) {
      compareTimes = columnInfo.compareTimes.map((compare) => {
        if (compare?.time_range && isEmpty(compare.last_time)) return compare;
        const value = columnInfo.operation === 'recent' ? columnInfo?.column_text?.split(' ~ ') ?? [] : columnInfo?.column_value;
        const {last_time, granularity} = compare || {};
        const range = getDateRange(value, {amount: last_time, granularity, timeGranularity: columnInfo.dateType});
        return {
          ...compare,
          time_range: formatDateRange(range, columnInfo.dateType),
        };
      });
    }
    
    const filterItem: FiltersItem = {
      table_code: columnInfo.table_code || "t0",
      table_id: columnInfo.table_id,
      column: columnInfo.column_name,
      filter_key: columnInfo?.filterKey,
      label: columnInfo.column_display,
      label_en: columnInfo.column_display_en,
      operation,
      is_full: columnInfo?.column_type === 'string' ? columnInfo?.isAll : undefined,
      value,
      filter_flag: 1, // 告诉后端, 筛选器新增了is_full字段的标志
      customValues: columnInfo.customValues,
      filter_method: columnInfo.filter_method,
      column_type: columnInfo.column_type,
      attribute: columnInfo.attribute,
      accuracy: columnInfo.accuracy,
      flag: columnInfo.flag,
      dimension_setting: columnInfo.dimension_setting,
      date_format: columnInfo.date_format,
      to_date_format: columnInfo.to_date_format || '',
      lastCount: columnInfo.lastCount,
      dateType: columnInfo.dateType,
      last_day: columnInfo.from,
      /**
       * scope_value是在承接页面, 虚拟版本下, 给报表筛选器配置的固定选项
       * 后端需要使用 scope_value进行计算
       * 在承接页面, 点击图表探索, 进入图表详情页面时, 发起的计算请求, 需要传递给后端
       * 由于承接页面的图表探索详情页面 无法进行图表保存, 所以 增加这个scope_value 不会影响原有报表.
       */
      scope_value: columnInfo.scope_value,
      compare_time: compareTimes,
      quick_value: columnInfo?.quickValue || {},
      filters: columnInfo?.filters,
    };
    if (filterItem.filter_method === FilterMethod.None) {
      // 如果是FilterMethod.None，强制转成后台所需的数据
      filterItem.operation = 'notNull';
    }
    return filterItem;
  });
  return newFilters;
};

export const createMetricsItem = (columnMetrics: IColumnInfo[], isRaw: boolean) => {
  const newMetrics: MetricsItem[] = (columnMetrics || []).map((item) => ({
    table_code: item.table_code || "t0",
    table_id: item.table_id,
    column: item.column_name,
    label: item.metric_alias ? item.metric_alias : item.column_display,
    label_en: item.metric_alias ? item.metric_alias : (item.column_display_en || item.column_display),
    column_type: item.column_type,
    aggregate: isRaw ? undefined : item.aggregate,
    alias: item.metric_alias,
    filters: item.metric_filters
      ? {
        filters: createFiltersItem(item.metric_filters),
        filters_connect_type: item.metric_filter_logic,
      }
      : undefined,
    attribute: item.attribute,
    accuracy: item.accuracy,
    unit: item.unit,
    flag: item.flag,
    dimension_setting: item.dimension_setting,
    date_format: item.date_format,
    to_date_format: item.to_date_format || '',
  }));
  return newMetrics;
};

export const createFilterCompares = (columnCompares: IColumnInfo[], isCalculate?: boolean) => {
  const newFilterCompares: AnalysisFilters[] = [];
  const newFilterCompare: FiltersItem[] = (columnCompares || []).map((item) => {
    
    let value = item?.column_value;
    if (item?.column_type === 'string' && isCalculate) {
      value = (item?.isAll ? [] : item?.column_value);
    }
    
    let operation = item.operation ?? '';
    // isCalculate 代表是计算接口
    if (isCalculate && item.operation === 'recent') {
      // 动态日期时, 上传的 value 和 operation要转换成静态日期值
      operation = 'between';
      value = item?.column_text?.split(' ~ ') ?? [];
      if (item.dateType === 'month') {
        value = [
          moment(value[0]).startOf('month').format('YYYY-MM-DD'),
          moment(value[1]).endOf('month').format('YYYY-MM-DD'),
        ];
      }
    }
  
    return {
      table_code: item.table_code || "t0",
      table_id: item.table_id,
      column: item.column_name,
      label: item.column_display,
      label_en: item.column_display_en,
      column_type: item?.column_type,
      operation,
      is_full: item?.isAll,
      value,
      filter_flag: 1, // 告诉后端, 筛选器新增了is_full字段的标志
      customValues: item.customValues,
      attribute: item.attribute,
      accuracy: item.accuracy,
      flag: item.flag,
      dimension_setting: item.dimension_setting,
      date_format: item.date_format,
      to_date_format: item.to_date_format || '',
      lastCount: item.lastCount,
      dateType: item.dateType,
      last_day: item.from,
    };
  });
  newFilterCompares[0] = { filters: newFilterCompare };
  return newFilterCompares;
};

export const getRequestUniqueId = () => `${getSessionGlobalUserId()}_${Date.now()}`;

